module.exports = __webpack_public_path__ + "img/3.b0db4202.png";